import { Directive, OnInit, OnDestroy, Input } from '@angular/core';
import { DataBindingDirective, GridComponent, RowClassArgs } from '@progress/kendo-angular-grid';
import { Subscription } from 'rxjs';
import { GridSettings } from '../_helpers/gridSettings';
import { StatePersistingService } from '../_services/state-persisting.service';

import { ListSecondService } from '../_services/list-second.service';
import { ColumnSettings } from '../_helpers/columnSettings';

@Directive({
  selector: '[appSecondTableData]'
})
export class SecondTableDataDirective  extends DataBindingDirective implements OnInit, OnDestroy{
  @Input('appSecondTableData') TableName: string;
  @Input() param1: string;
  
  private serviceSubscription: Subscription;
  public gridSettings: GridSettings;
  private refreshSubscription: Subscription;

  constructor(private lists: ListSecondService, grid: GridComponent, public persistingService: StatePersistingService) {
    super(grid);
  }

  public get savedStateExists(): boolean {
    return !!this.persistingService.get('gridSettings');
  }
  public ngOnInit(): void {

    this.lists.tableName = this.TableName;
    this.lists.param1 = this.param1;
    
    const gridSettings: GridSettings = this.persistingService.get(this.TableName + 'gridSettings');

    if (gridSettings !== null) {
      this.gridSettings = this.mapGridSettings(gridSettings);
      this.state = this.gridSettings.state;
    }
    this.serviceSubscription = this.lists.subscribe(result => {
      this.grid.loading = false;
      this.grid.data = result;
      this.notifyDataChange();
    });

    super.ngOnInit();

    this.rebind();
    this.refreshSubscription = this.lists.refreshTrigger.subscribe((tableName: string) => {
      this.rebind();
    });
  }

  public ngOnDestroy(): void {
    if (this.serviceSubscription) {
      this.serviceSubscription.unsubscribe();
    }
    if (this.refreshSubscription) {
      this.refreshSubscription.unsubscribe();
    }
    this.saveGridSettings(this.grid);
    super.ngOnDestroy();
  }

  public rebind(): void {
    this.grid.loading = true;

    this.lists.query(this.state);
  }

  saveGridSettings(grid: GridComponent): void {
    const columns = grid.columns;

    const gridConfig = {
      state: this.state,
      columnsConfig: columns.toArray().map(item =>
        Object.keys(item)
          .filter(propName => !propName.toLowerCase().includes('template'))
          .reduce((acc, curr) => ({ ...acc, ...{ [curr]: item[curr] } }), <ColumnSettings>{})
      )
    };

    this.persistingService.set(this.TableName + 'gridSettings', gridConfig);
  }
  public mapGridSettings(gridSettings: GridSettings): GridSettings {
    const state = gridSettings.state;
    if (state.filter !== undefined) {
      this.mapDateFilter(state.filter);
    }

    return {
      state,
      columnsConfig: gridSettings.columnsConfig.sort((a, b) => a.orderIndex - b.orderIndex)
    };
  }
  private mapDateFilter = (descriptor: any) => {
    const filters = descriptor.filters || [];
    filters.forEach(filter => {
      if (filter.filters) {
        this.mapDateFilter(filter);
      } else if (filter.value) {
        if (this.isDate(filter.value)) {
          filter.value = new Date(filter.value);
        }
      }
    });
  }
  private isDate(input) {
    const timestamp = Date.parse(input);

    if (isNaN(timestamp) === false) {
      return true;
    }else {
      return false;
    }
  }


}
